//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["segments","allStock","specStocks","maintain_stock","copy_bend_corners","maintain","use_minimum_bend_ratio","minimum_bend_ratio","minimum_bend_radius","delete_all_duplicates","create_associative_paths","pattern_x_vector","pattern_y_vector","pattern_axis_end_point","pattern_start_angle","radial_offset","n_paths","total_angle","n_slave_paths_created","slave_paths_created"],"CreateCircularOffsetPath",{R_:{master_offset_path:"Routing.OffsetPath"}},18,0],[["segments","allStock","specStocks","maintain_stock","copy_bend_corners","maintain","use_minimum_bend_ratio","minimum_bend_ratio","minimum_bend_radius","delete_all_duplicates","create_associative_paths","pattern_x_vector","pattern_y_vector","pattern_axis_end_point","pattern_start_angle","row_offset","column_offset","n_rows","n_columns","master_row","master_column","n_slave_paths_created","slave_paths_created"],"CreateRectangularOffsetPath",{R_:{master_offset_path:"Routing.OffsetPath"}},21,0],[["master_offset_path"],"ConvertOffsetPaths",{},1,0]],[]];
SPLM.Routing.OffsetPathCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.OffsetPathCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Routing.OffsetPathCollection.BendType = Object.freeze({
    "MaintainRadius" : "MaintainRadius", "MaintainCenter" : "MaintainCenter", "MaximumBendTypes" : "MaximumBendTypes"});

export default SPLM;